var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334 422l-101 39c-17 6-36 1-46-14l-19-27a13 13 0 1 1 21-15l19 27c3 5 10 7 15 4l101-39a13 13 0 0 0 6-20l-9-12a13 13 0 1 1 22-16l9 13c7 10 9 23 5 34-3 12-12 21-23 26z",
    fill: "#fe9923"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd4e26",
    d: "M477 310L298 57 32 366l65 92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd3018",
    d: "M477 310l-90-127L64 412l33 46z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117 487c-12 8-28 5-36-6L5 373c-9-11-6-28 6-36 12-9 28-6 37 6l76 107c8 12 5 29-7 37z",
    fill: "#fcbf29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 427l38 54a26 26 0 0 0 43-31l-38-53z",
    fill: "#fe9923"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M501 344c-12 9-28 6-37-6L267 59c-8-12-5-28 6-36 12-9 29-6 37 6l197 279c9 11 6 28-6 36z",
    fill: "#fcbf29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M366 199l98 139a26 26 0 0 0 43-30l-98-140z",
    fill: "#fe9923"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.dfdbe4afdd6482f4289533185fbefc45.svg";
export { ForwardRef as ReactComponent };